import {useState} from 'react';
import {useSelector} from 'react-redux';
import {RootState} from '~/redux/root-reducer';

interface PusherData {}

export function useListenEventPusher<Data extends PusherData>(channel: string, event: string) {
  const token = useSelector((state: RootState) => state.auth.token)!;
  const [isLoadingPage, setIsLoadingPage] = useState<boolean>(false);
  const [data, setData] = useState<Data>();

  const setLoaded = () => {
    setIsLoadingPage(false);
  };

  // useEffect(() => {
  //   const pusher = initPusher(token);
  //   pusher.subscribe(channel).bind(event, (msg: Data) => {
  //     setData(msg);
  //     setIsLoadingPage(true);
  //   });
  //   return () => {
  //     pusher.unsubscribe(channel);
  //   };
  // }, [channel, event, token]);

  return {data, isLoadingPage, setLoaded};
}

export default useListenEventPusher;
